import React from 'react';
import { useTranslation } from 'react-i18next'; 
import WineDispenserImg from "../../../assets/images/WineDispenser.png";


function WineDispenserComponent() {
  const { t } = useTranslation(); 

  const products = [
    {
      name: t("Wine Dispenser"),
      description: t(
        "In the world of gastronomy comfort is essential not only for the consumers but also staff members of bars, cafes, restaurants etc. Enomatic wine dispensers offer perfect combination of comfort and quality in their wine dispensers."
      ),
      img: WineDispenserImg,
    },
    
  ];

  return (
    <div className="main-infocontainer">
      {products.map((product, index) => (
        <div className="item-container" key={index}>
          <img src={product.img} alt={product.name} /> 
          <div className="text-info">
            <h1>{product.name}</h1>
            <p>{product.description}</p>
          </div>
        </div>
      ))}
    </div>
  );
}

export default WineDispenserComponent;
